// Import Dependencies
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

// Import Components
import ConcertCard from '../ConcertCard';
import BookTicketsModal from '../BookTicketsModal';
import Button from '../Button';

// Import Utilities
import { sleep, addClass, removeClass } from '../../../utils';

class ConcertCardList extends Component {
  constructor() {
    super();

    this.calendarContainer = document.querySelector('.js-calendar');

    this.state = {
      show: false,
      activeConcert: null,
      visible: 6,
      wishlist: window.WishlistManager ? window.WishlistManager.wishlist : [],
    };
  }

  // Fix the vertical scrollbar width issue on card list wrapper
  setRef = (cardListSection) => {
    if (!cardListSection) return;
    const windowWidth = window.innerWidth;
    cardListSection.style.width = `${windowWidth}px`;
  };

  handleLoadMore = () => {
    this.setState((prevState) => ({
      visible: prevState.visible + 6,
    }));
  };

  showModal = async (concert) => {
    // Delay for animation
    await sleep(50);

    await this.setState({
      show: true,
      activeConcert: concert,
    });

    await addClass(this.calendarContainer, 'has-modal-open');
  };

  hideModal = async () => {
    this.setState({
      show: false,
    });

    await removeClass(this.calendarContainer, 'has-modal-open');

    // Delay for animation
    await sleep(500);

    await this.setState({
      activeConcert: null,
    });
  };

  toggleWishlist = (concert) => {
    const { wishlist } = this.state;
    const id = concert.entryId.toString();

    if (wishlist.includes(id)) {
      this.setState((prev) => ({
        wishlist: prev.wishlist.filter((v) => v !== id),
      }));

      window.WishlistManager.removeFromWishlist(id);
    } else if (!wishlist.includes(id)) {
      this.setState((prev) => ({
        wishlist: [...prev.wishlist, id],
      }));
      window.WishlistManager.addToWishlist(id);
    }
  };

  render() {
    const {
      concerts,
      ...props
    } = this.props;
    const {
      show,
      activeConcert,
      visible,
      wishlist,
    } = this.state;

    return (
      <>
        <section className="o-section  o-section--padding-bottom-medium" ref={this.setRef}>
          <div className="o-container  o-container--padding-left-xlarge@large">
            <div className="o-grid">
              <div className="o-col  o-col--10@small  o-col--offset-1@small">
                <div className="o-col__inner">
                  <div className="c-card-listing  c-card-listing--large  c-card-listing--full-height  u-spacing-top-large@large">
                    <div className="c-card-listing__wrapper">
                      <div className="c-card-listing__content">
                        {concerts
                          && concerts.length > 0
                          && concerts.filter((concert) => !Array.isArray(concert) && concert.date !== 0)
                            .slice(0, visible)
                            .map((concert) => (
                              <ConcertCard
                                dark
                                loaded
                                key={concert.entryId}
                                toggleWishlist={() => this.toggleWishlist(concert)}
                                inWishlist={wishlist.includes(concert.entryId.toString())}
                                handlePerformancesModal={() => this.showModal(concert)}
                                {...concert}
                                {...props}
                              />
                            ))}

                        {visible < concerts.length && (
                          <div className="c-card-listing__loadmore">
                            <Button white onClick={this.handleLoadMore}><span>Load more</span></Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <BookTicketsModal
          show={show}
          handleClose={this.hideModal}
          title={activeConcert ? activeConcert.title : ''}
          dates={activeConcert ? activeConcert.teaser : ''}
          performanceList={activeConcert ? activeConcert.performances : null}
        />
      </>
    );
  }
}

ConcertCardList.propTypes = {
  concerts: PropTypes.arrayOf(PropTypes.shape({})),
  apiUrl: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

ConcertCardList.defaultProps = {
  concerts: null,
  loading: true,
};

export default ConcertCardList;
